var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 37H25C24.7348 37 24.4804 36.8946 24.2929 36.7071C24.1054 36.5196 24 36.2652 24 36V34C24 33.7348 24.1054 33.4804 24.2929 33.2929C24.4804 33.1054 24.7348 33 25 33H34C34.2652 33 34.5196 33.1054 34.7071 33.2929C34.8946 33.4804 35 33.7348 35 34V36C35 36.2652 34.8946 36.5196 34.7071 36.7071C34.5196 36.8946 34.2652 37 34 37Z",
    fill: "#D6B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13H16C15.7348 13 15.4804 13.1054 15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14V16C15 16.2652 15.1054 16.5196 15.2929 16.7071C15.4804 16.8946 15.7348 17 16 17H34C34.2652 17 34.5196 16.8946 34.7071 16.7071C34.8946 16.5196 35 16.2652 35 16V14C35 13.7348 34.8946 13.4804 34.7071 13.2929C34.5196 13.1054 34.2652 13 34 13Z",
    fill: "#11B5E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19H16C15.7348 19 15.4804 19.1054 15.2929 19.2929C15.1054 19.4804 15 19.7348 15 20V30C15 30.2652 15.1054 30.5196 15.2929 30.7071C15.4804 30.8946 15.7348 31 16 31H34C34.2652 31 34.5196 30.8946 34.7071 30.7071C34.8946 30.5196 35 30.2652 35 30V20C35 19.7348 34.8946 19.4804 34.7071 19.2929C34.5196 19.1054 34.2652 19 34 19Z",
    fill: "#11B5E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2);
export default __webpack_public_path__ + "static/media/item2.e38aac2a777ec31b3000314b9d38ef72.svg";
export { ForwardRef as ReactComponent };